var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeicon = function SvgEyeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.44 8.7C14.925 5.183 12.075 3 9 3S3.075 5.183 1.56 8.7a.75.75 0 0 0 0 .6C3.075 12.818 5.925 15 9 15s5.925-2.182 7.44-5.7a.75.75 0 0 0 0-.6zM9 13.5c-2.378 0-4.628-1.717-5.925-4.5C4.372 6.218 6.622 4.5 9 4.5c2.377 0 4.627 1.718 5.925 4.5-1.298 2.783-3.548 4.5-5.925 4.5zM9 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
  })));
};
export default SvgEyeicon;